<script setup>
defineOptions({ inheritAttrs: false });

const props = defineProps({
  pillText: {
    type: String,
    required: true,
  },
  pillSubText: {
    type: String,
    default: '',
  },
  pillLink: {
    type: String,
    required: true,
  },
  pillBorderRadius: {
    type: String,
    default: '',
    validator: (val) => !val || ['xl', 'l', 'm', 's'].includes(val),
  },
});

const pillAriaLabel = computed(() => (props.pillSubText ? `${props.pillText}, ${props.pillSubText}` : props.pillText));

const pillClasses = computed(() => {
  const classes = ['pill'];
  if (props.pillBorderRadius) {
    classes.push(`pill-radius-${props.pillBorderRadius}`);
  }
  return classes;
});
</script>

<template>
  <a
    :href="pillLink"
    v-bind="$attrs"
    :class="pillClasses"
    :aria-label="pillAriaLabel"
  >
    {{ pillText }}
    <span v-if="pillSubText">{{ pillSubText }}</span>
  </a>
</template>

<style lang="scss" scoped>
.pill {
  @include body-1-bld;

  display: block;
  padding: wds-rem(12px) $wds-spacing-l;
  background-color: $wds-color-purple;
  color: $wds-color-white;
  border-radius: $wds-spacing-l;
  text-align: left;
  text-decoration: none;
  outline: none;

  & span {
    @include body-3-reg;

    display: block;
  }

  &:hover {
    box-shadow: $wds-shadow-light-l;
  }

  &[disabled] {
    opacity: $wds-opacity-medium;
  }

  &:focus-visible {
    box-shadow:
      0 0 0 0.125rem $wds-color-white,
      0 0 0 0.25rem $wds-color-ink-darker;
  }
}

.pill-radius-s {
  border-radius: $wds-spacing-s;
}

.pill-radius-m {
  border-radius: $wds-spacing-m;
}

.pill-radius-l {
  border-radius: $wds-spacing-l;
}

.pill-radius-xl {
  border-radius: $wds-spacing-xl;
}
</style>
